import React from 'react';
import { Flow as AddEmailFlow } from './AddEmail';
import { Flow as AddPhoneFlow } from './AddPhone';
import { Flow as AddEmailAndPhoneFlow } from './AddEmailAndPhone';

interface FlowsProviderProps {
  children: React.ReactNode;
}

const FlowsProvider = ({ children }: FlowsProviderProps): JSX.Element => {
  return (
    <AddEmailFlow>
      <AddPhoneFlow>
        <AddEmailAndPhoneFlow>{children}</AddEmailAndPhoneFlow>
      </AddPhoneFlow>
    </AddEmailFlow>
  );
};

export { FlowsProvider };
